import GlobalStore from "@ipru-common/store/GlobalStore";
import getSIPPlusNetCoreInput from "./SipPlusNetcoreInput";
import FundsStore from "@ipru-common/store/FundsStore";
import { OPTION_VALUES } from "@ipru-common/constants/InputValues";

const getSignatureSIPPlusNetCoreInput = () => {
  const { quoteFormData, navFundReleasedCode } = GlobalStore.getSnapshot();
  let signatureAssureInput = getSIPPlusNetCoreInput();
  const { familyIncomePercent } = quoteFormData;
  const urlParams = new URLSearchParams(window?.location?.search);
  const params = Object.fromEntries(urlParams?.entries());
  const fundData = FundsStore.getInvestedFundValues();

  const maturityBenefitValue = quoteFormData?.calculatedData?.returns?.pastPerformance?.onlineReturn;

  signatureAssureInput = {
    ...signatureAssureInput,
    "familyincome%": familyIncomePercent,
    currentPageStep: signatureAssureInput?.currentpagestep,
    isEnglish: params?.lan === "hindi" || params?.lan === "hi" ? "FALSE" : "TRUE",
    Maturity_benefit_FP1: quoteFormData?.returnYears === 1 ? maturityBenefitValue : "",
    Maturity_benefit_FP3: quoteFormData?.returnYears === 3 ? maturityBenefitValue : "",
    Maturity_benefit_FP5: quoteFormData?.returnYears === 5 ? maturityBenefitValue : "",
    NFOopt: navFundReleasedCode ? String(quoteFormData?.nfoOpt || OPTION_VALUES.N_NO).toLowerCase() : undefined,
    ...Object.fromEntries(
      fundData
        ?.map((item, index) => [
          [`InvValue_${(index + 1) * 5}Y`, item.fund],
          [`FV_${(index + 1) * 5}Y`, item.growth],
        ])
        .flat()
    ),
  };

  return signatureAssureInput;
};

export default getSignatureSIPPlusNetCoreInput;
